var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 14,
    viewBox: "0 0 138 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.865 0.375786H124.46L129.254 5.93496L134.058 0.351562H137.696L130.696 8.5026V13.7227L127.822 13.7348L127.812 13.7227C127.822 13.7348 127.822 8.53894 127.822 8.53894",
    fill: "#FF9999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.902 0.339111V13.7708H108.755V8.2237H115.161L115.606 5.65606C115.606 5.64395 115.606 5.64395 115.606 5.63184L108.776 5.64395V2.89464L118.406 2.88253L118.841 0.351223L105.902 0.339111Z",
    fill: "#FF9999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.233 0.302734H99.3906V13.6617H102.233V0.302734Z",
    fill: "#FF9999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2085 0.375446V0.339111H82.1143C82.1143 0.339111 82.1143 2.91886 82.1143 2.89464V2.91886H87.7244V13.7829H90.5878V2.89464H95.7843L96.2085 0.375446Z",
    fill: "#FF9999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9453 0.375786H67.7875V6.57687L75.6035 0.351562L79.5274 0.363674L72.984 5.60795L80.0895 13.7469H76.3247L70.81 7.3399L67.7875 9.73797V13.7469H64.9453V0.375786Z",
    fill: "#FF9999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7422 11.2031V11.1789H51.6991V8.21159L58.0728 8.18736L58.5076 5.64395H51.6885V2.89464L61.2967 2.90675L61.7316 0.351223V0.339111H48.8145V13.7587H61.2967L61.7422 11.2031Z",
    fill: "#FF9999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6943 0.326904V13.7586H35.5471V8.21149H41.9527L42.3981 5.64385V5.63174L35.5577 5.64385V2.88243L45.1872 2.87032L45.6221 0.339016L32.6943 0.326904Z",
    fill: "#FF9999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6172 0.326904V13.7586H19.47V8.21149H25.8755L26.3103 5.65596C26.3103 5.64385 26.3103 5.63174 26.3103 5.63174L19.4806 5.64385V2.88243L29.1101 2.87032L29.5449 0.326904H16.6172Z",
    fill: "#FF9999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 11.1789H3.37107V8.19948L9.74479 8.17525L10.1796 5.65606C10.1796 5.64395 10.1796 5.64395 10.1796 5.63184H3.36047V2.89464L12.9688 2.91886L13.4142 0.339111H0.49707V13.7708H12.9794L13.4142 11.1789Z",
    fill: "#FF9999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e42d7c9ef471cf587b572b5b7bf0c0bc.svg";
export { ForwardRef as ReactComponent };